import React, { Fragment } from 'react';
import { observer } from 'mobx-react';
import { http } from '../../services/HttpInterceptor';
import {
    RouteComponentProps, Link
} from "react-router-dom";
import { toast } from 'react-toastify';
import swal from 'sweetalert';
import { observable } from 'mobx';
import { formatRelative } from 'date-fns'
import { es } from 'date-fns/locale'
import DatePicker from "react-datepicker";
import { createBrowserHistory } from "history";
import { sessionService } from '../../services/SessionService';
import Pagination from "react-js-pagination";
import { apiUrl } from '../../services/HttpInterceptorUtil';

interface IndexBillsProps extends RouteComponentProps {
    changeToggle(action?: boolean): void
}
const history = createBrowserHistory({ forceRefresh: true });
@observer export default class IndexBills extends React.Component<IndexBillsProps> {

    @observable private fromDate: Date = new Date();
    @observable private toDate: Date = new Date();
    @observable private payments: any;
    @observable private isLoaded = false;
    @observable private total: number = 0;
    @observable private pages: any = [];
    @observable private page: any = 1;
    @observable private type: any = "";
    @observable private status: any = "";
    @observable private sortBy: any = "p.id";
    @observable private sortOrder: any = "DESC";
    @observable private cards: any = [];
    @observable private card: string = "";
    @observable private search: string = "";
    @observable private results: any = [];
    @observable private searching: boolean = false;
    @observable private types: any = [{
        name: "Cobrador", value: "Cobrador"
    }, {
        name: "Transferencia", value: "Transferencia"
    }, {
        name: "Deposito", value: "Deposito"
    }, {
        name: "Tecnico", value: "Tecnico"
    }];

    @observable private statuses: any = [{
        name: "Pendiente", value: "Pendiente"
    }, {
        name: "Aprobado", value: "Aprobado"
    }, {
        name: "Rechazado", value: "Rechazado"
    }];

    componentDidMount() {
        this.props.changeToggle(true);
        this.init();
    }

    onChange = (event: any) => {
        if (event.target.name === "type") {
            this.type = event.target.value;
        } else if (event.target.name === "card") {
            this.card = event.target.value;
        } else if (event.target.name === "status") {
            this.status = event.target.value;
        }
    }

    init = () => {
        return http.post('/api/payment/read', JSON.stringify({ page: 1, sort_by: this.sortBy, sort_order: this.sortOrder })).then((response) => {
            this.payments = response.data.response.data;
            this.total = response.data.response.total;
            this.pages = [...Array(Math.ceil(this.total / 50))];
            return http.get('api/card/read').then((response) => {
                this.cards = response.data.response;
                this.isLoaded = true;
            });
        }).catch((error) => {
            toast.error("Error cargando pagos");
        });
    }

    changePage = (page: any) => {
        this.page = page;
        const obj = JSON.stringify({
            page: this.page,
            from: `${this.fromDate.getFullYear()}-${("0" + (this.fromDate.getMonth() + 1)).slice(-2)}-${("0" + this.fromDate.getDate()).slice(-2)} 00:00:00`,
            to: `${this.toDate.getFullYear()}-${("0" + (this.toDate.getMonth() + 1)).slice(-2)}-${("0" + this.toDate.getDate()).slice(-2)} 23:59:59`,
            type: this.type,
            sort_by: this.sortBy,
            sort_order: this.sortOrder,
            card: this.card
        });
        http.post(`/api/payment/read`, obj).then((response) => {
            this.payments = response.data.response.data;
            this.total = response.data.response.total;
            this.pages = [...Array(Math.ceil(this.total / 50))];
            this.isLoaded = true;
        }).catch((error) => {
            toast.error("Error cargando contratos");
        });
    }

    searchByDate = () => {
        if (this.fromDate === null || this.toDate === null) {
            toast.error("Debes seleccionar un rango de fechas");
            return;
        }
        const obj = JSON.stringify({
            page: 1,
            type: this.type,
            from: `${this.fromDate.getFullYear()}-${("0" + (this.fromDate.getMonth() + 1)).slice(-2)}-${("0" + this.fromDate.getDate()).slice(-2)} 00:00:00`,
            to: `${this.toDate.getFullYear()}-${("0" + (this.toDate.getMonth() + 1)).slice(-2)}-${("0" + this.toDate.getDate()).slice(-2)} 23:59:59`,
            sort_by: this.sortBy,
            sort_order: this.sortOrder,
            card: this.card,
            status: this.status
        });
        http.post(`/api/payment/read`, obj).then((response) => {
            this.payments = response.data.response.data;
            this.total = response.data.response.total;
            this.pages = [...Array(Math.ceil(this.total / 50))];
        }).catch(() => {
            toast.error("Error cargando recibos");
        })
    }

    changeSort = (value: string) => {
        this.sortBy = value;
        this.sortOrder = this.sortOrder === "DESC" ? "ASC" : "DESC";
        this.changePage(this.page);
    }

    setStartDate = (date: any, input: string) => {
        if (input === "from") {
            this.fromDate = date;
        } else {
            this.toDate = date;
        }
    }

    private deletePayment = (id: any, index: any): void => {
        swal({
            title: "Confirmar acción",
            text: "¿Estas seguro que quieres borrar este pago?",
            icon: "warning",
            dangerMode: true,
        })
            .then(willDelete => {
                if (willDelete) {
                    const deleteObject = JSON.stringify({
                        id
                    });
                    http.post(`/api/payment/delete`, deleteObject)
                        .then((response) => {
                            this.payments.splice(index, 1);
                            toast.success("Pago borrado correctamente");
                        }).catch((error) => {
                            if (error.includes("foreign")) {
                                toast.error("Error al borrar: Registros ligados a este pago");
                            } else {
                                toast.error("Error borrando pago");
                            }
                        })
                }
            });
    }

    private approvePayment = (id: any, index: any): void => {
        swal({
            title: "Confirmar acción",
            text: "¿Estas seguro que quieres aprobar este pago?",
            icon: "warning",
            dangerMode: false,
        })
            .then(willDelete => {
                if (willDelete) {
                    const approveObject = JSON.stringify({
                        id
                    });
                    http.post(`/api/payment/approve`, approveObject)
                        .then((response) => {
                            this.payments[index].status = 'Aprobado';
                            toast.success("Pago aprobado correctamente");
                            this.payments.splice(index, 1);
                        }).catch((error) => {
                            if (error.includes("foreign")) {
                                toast.error("Error al aprobar pago: Registros ligados a este pago");
                            } else {
                                toast.error("Error aprobando pago");
                            }
                        })
                }
            });
    }

    private rejectPayment = (id: any, index: any): void => {
        swal({
            title: "Confirmar acción",
            text: "¿Estas seguro que quieres rechazar este pago?",
            icon: "warning",
            dangerMode: false,
        })
            .then(willDelete => {
                if (willDelete) {
                    const approveObject = JSON.stringify({
                        id
                    });
                    http.post(`/api/payment/reject`, approveObject)
                        .then((response) => {
                            this.payments[index].status = 'Rechazado';
                            toast.success("Pago rechazado correctamente");
                            this.payments.splice(index, 1);
                        }).catch((error) => {
                            if (error.includes("foreign")) {
                                toast.error("Error al rechazar pago: Registros ligados a este pago");
                            } else {
                                toast.error("Error rechazando pago");
                            }
                        })
                }
            });
    }

    onSearchChange = (event: any) => {
        this.search = event.target.value;
    }

    searchPayments = () => {
        if (this.search.length === 0) {
            this.searching = false;
            return;
        }
        const search = {
            folio: this.search
        }
        http.post('/api/payment/search', JSON.stringify(search)).then((response) => {
            if (response.data.response.data.length > 0) {
                this.results = response.data.response.data;
                this.searching = true;
            } else {
                toast.error("No se encontraron pagos");
            }
        }).catch(() => {
            toast.error("Error cargando pagos");
        });
    }

    enterPressed = (event: any) => {
        let code = event.keyCode || event.which;
        if (code === 13) {
            this.searchPayments();
        }
    }

    private generateInvoice = (id: any): void => {
        http.get(`/api/payment/factura/${id}`)
            .then((response) => {
                console.log(response.data);
                if (response.data.success === true) {
                    toast.success("Factura generada correctamente");
                    this.payments.find((payment: any) => payment.id === id).cfdi = response.data.data.uuid;
                } else {
                    toast.error("Error generando factura");
                }
            }).catch((error) => {
                console.error(error);
                toast.error("Error generando factura: " + error);
            })
    }

    private downLoadInvoice = (id: any, cfdi:any): void => {
        window.open(`${apiUrl().url.API_URL}/api/payment/factura_download/${id}/${cfdi}`, "_blank")
    }

    private cancelInvoice = (id: any): void => {
    swal({
        title: "Confirmar acción",
        text: "¿Estás seguro que quieres cancelar esta factura?",
        icon: "warning",
        dangerMode: false,
    })
        .then(willDelete => {
            if (willDelete) {
                http.get(`/api/payment/factura_cancelacion/${id}`)
                    .then((response) => {
                        if (response.data.success === true) {
                            toast.success("Factura cancelada correctamente");
                            this.payments.find((payment: any) => payment.id === id).cfdi = null;
                        } else {
                            toast.error("Error cancelando factura");
                        }
                    }).catch((error) => {
                        console.error(error);
                        toast.error("Error cancelando factura");
                    });
            }
        });
}

    render() {
        if (!this.isLoaded) {
            return null;
        }
        return (
          <Fragment>
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-sm-4">
                        {sessionService.canViewSection("Facturas.view") && (
                          <Link to={`/facturas/descargar`}>
                            <button className="btn btn-success btn-lg">
                              <i className="material-icons">download</i>{" "}
                              Descargar Facturas
                              <div className="ripple-container"></div>
                            </button>
                          </Link>
                        )}
                      </div>
                      <div className="col-sm-4 text-center">
                        {sessionService.canViewSection("Facturas.view") && (
                          <Link to={`/facturas/mes`}>
                            <button className="btn btn-primary btn-lg">
                              <i className="material-icons">calendar_month</i>{" "}
                              Facturas del mes
                              <div className="ripple-container"></div>
                            </button>
                          </Link>
                        )}
                      </div>
                      <div className="col-sm-4">
                        {sessionService.canViewSection("Facturas.add") && (
                          <Link to={`/facturas/emisor`}>
                            <button className="btn btn-info btn-lg pull-right">
                              <i className="material-icons">account_circle</i>{" "}
                              Datos de emisor
                              <div className="ripple-container"></div>
                            </button>
                          </Link>
                        )}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="form-group bmd-form-group is-filled">
                          <input
                            type="text"
                            name="search"
                            autoComplete="off"
                            placeholder="Buscar pagos por folio o direccion..."
                            onChange={this.onSearchChange}
                            className="form-control"
                            value={this.search}
                            onKeyPress={this.enterPressed}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header card-header-primary">
                    <h4 className="card-title ">Lista de pagos</h4>
                    <p className="card-category">Lista de pagos registrados</p>
                  </div>
                  <div className="card-body">
                    {this.total > 50 && (
                      <div className="row">
                        <Pagination
                          activePage={this.page}
                          itemsCountPerPage={50}
                          totalItemsCount={Number(this.total)}
                          pageRangeDisplayed={5}
                          onChange={this.changePage.bind(this)}
                          activeClass="btn-warning"
                          itemClass="btn btn-round btn-info"
                          innerClass="btn-group paginador"
                          disabledClass="deshabilitado"
                        />
                      </div>
                    )}
                    <div className="table-responsive">
                      <table className="table">
                        <thead className=" text-primary">
                          <tr>
                            <th></th>
                            <th>
                              <div className="form-group bmd-form-group">
                                <select
                                  name="status"
                                  onChange={this.onChange}
                                  value={this.status}
                                  className="form-control custom-select"
                                >
                                  <option value="">--Todos</option>
                                  {this.statuses &&
                                    this.statuses.map(
                                      (option: any, index: any) => {
                                        return (
                                          <option value={option.id} key={index}>
                                            {option.name}
                                          </option>
                                        );
                                      }
                                    )}
                                </select>
                              </div>
                            </th>
                            <th>
                              <div className="form-group bmd-form-group">
                                <select
                                  name="type"
                                  onChange={this.onChange}
                                  value={this.type}
                                  className="form-control custom-select"
                                >
                                  <option value="">--Todos</option>
                                  {this.types &&
                                    this.types.map(
                                      (option: any, index: any) => {
                                        return (
                                          <option value={option.id} key={index}>
                                            {option.name}
                                          </option>
                                        );
                                      }
                                    )}
                                </select>
                              </div>
                            </th>
                            <th>
                              Desde:{" "}
                              <DatePicker
                                selected={this.fromDate}
                                onChange={(date) =>
                                  this.setStartDate(date, "from")
                                }
                              />
                            </th>
                            <th>
                              Hasta:{" "}
                              <DatePicker
                                selected={this.toDate}
                                onChange={(date) =>
                                  this.setStartDate(date, "to")
                                }
                              />
                            </th>
                            <th>
                              {sessionService.canViewSection("Pagos.card") && (
                                <div className="form-group bmd-form-group">
                                  <select
                                    name="card"
                                    onChange={this.onChange}
                                    value={this.card}
                                    className="form-control custom-select"
                                  >
                                    <option value="">--Todas Tarjetas</option>
                                    {this.cards &&
                                      this.cards.map(
                                        (option: any, index: any) => {
                                          return (
                                            <option
                                              value={option.id}
                                              key={index}
                                            >
                                              {option.name}
                                            </option>
                                          );
                                        }
                                      )}
                                  </select>
                                </div>
                              )}
                            </th>
                            <th>
                              <button
                                onClick={this.searchByDate}
                                className="btn btn-info btn-sm "
                              >
                                <i className="material-icons">search</i> Buscar
                                <div className="ripple-container"></div>
                              </button>
                            </th>
                            <th>Total {this.total}</th>
                          </tr>
                          <tr>
                            <th
                              onClick={() => this.changeSort("p.id")}
                              style={{ cursor: "pointer" }}
                            >
                              ID
                            </th>
                            <th
                              onClick={() => this.changeSort("p.contract_id")}
                              style={{ cursor: "pointer" }}
                            >
                              Contrato #
                            </th>
                            <th
                              onClick={() => this.changeSort("p.invoice_id")}
                              style={{ cursor: "pointer" }}
                            >
                              Recibo #
                            </th>
                            <th
                              onClick={() => this.changeSort("p.client_name")}
                              style={{ cursor: "pointer" }}
                            >
                              Cliente
                            </th>
                            <th
                              onClick={() => this.changeSort("cutoff_date")}
                              style={{ cursor: "pointer" }}
                            >
                              Corte
                            </th>
                            <th
                              onClick={() => this.changeSort("cl.phone")}
                              style={{ cursor: "pointer" }}
                            >
                              Telefono
                            </th>
                            <th
                              onClick={() => this.changeSort("p.status")}
                              style={{ cursor: "pointer" }}
                            >
                              Estatus
                            </th>
                            <th
                              onClick={() => this.changeSort("p.date")}
                              style={{ cursor: "pointer" }}
                            >
                              Fecha de Pago
                            </th>
                            <th
                              onClick={() => this.changeSort("p.type")}
                              style={{ cursor: "pointer" }}
                            >
                              Tipo de Pago
                            </th>
                            <th
                              onClick={() => this.changeSort("address")}
                              style={{ cursor: "pointer" }}
                            >
                              Direccion
                            </th>
                            <th
                              onClick={() => this.changeSort("p.amount")}
                              style={{ cursor: "pointer" }}
                            >
                              Cantidad
                            </th>
                            <th
                              onClick={() => this.changeSort("p.created_date")}
                              style={{ cursor: "pointer" }}
                            >
                              Fecha
                            </th>
                            <th className="text-right">Acciones</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.searching &&
                            this.results.map((payment: any, index: any) => {
                              const backgroundColor = () => {
                                if (
                                  (payment.type === "Deposito" ||
                                    payment.type === "Transferencia") &&
                                  payment.status === "Aprobado"
                                ) {
                                  return "approved";
                                }

                                if (
                                  (payment.type === "Deposito" ||
                                    payment.type === "Transferencia") &&
                                  payment.status === "Rechazado"
                                ) {
                                  return "rejected";
                                }

                                if (
                                  (payment.type === "Deposito" ||
                                    payment.type === "Transferencia") &&
                                  payment.status === "Pendiente"
                                ) {
                                  return "pending";
                                }

                                return "approved";
                              };

                              return (
                                <Fragment key={index}>
                                  <tr className={backgroundColor()}>
                                    <td>{payment.id}</td>
                                    <td
                                      onClick={() => {
                                        const baseUrl = new URL(
                                          apiUrl().url.API_URL
                                        ).hostname;
                                        const contractId =
                                          baseUrl ===
                                          "wirserv.serviciosinalambricos.com.mx"
                                            ? `W${payment.contract_id}`
                                            : payment.contract_id;
                                        if (contractId)
                                          history.push(
                                            `/contratos/ver/${contractId}`
                                          );
                                      }}
                                      style={{ cursor: "pointer" }}
                                    >
                                      {" "}
                                      {payment.contract_id}
                                    </td>
                                    <td
                                      onClick={() =>
                                        payment.invoice_id
                                          ? history.push(
                                              `/recibos/ver/${payment.invoice_id}`
                                            )
                                          : ""
                                      }
                                      style={{ cursor: "pointer" }}
                                    >
                                      {payment.invoice_id
                                        ? payment.invoice_id
                                        : "A favor"}
                                    </td>
                                    <td>{payment.client_name}</td>
                                    <td>{payment.cutoff_date}</td>
                                    <td>{payment.phone}</td>
                                    <td>
                                      {payment.type === "Deposito" ||
                                      payment.type === "Transferencia"
                                        ? payment.status
                                        : ""}
                                    </td>
                                    <td>{payment.date}</td>
                                    <td>{payment.type}</td>
                                    <td>{payment.address}</td>
                                    <td>{payment.amount}</td>
                                    <td>
                                      {formatRelative(
                                        new Date(payment.created_date),
                                        new Date(),
                                        { locale: es }
                                      )}
                                    </td>
                                    <td className="td-actions text-right">
                                      {sessionService.canViewSection(
                                        "Facturas.view"
                                      ) &&
                                        payment.cfdi != null && (
                                          <button
                                            onClick={() =>
                                              this.downLoadInvoice(payment.id, payment.cfdi)
                                            }
                                            style={{ margin: 5 }}
                                            type="button"
                                            className="btn btn-info"
                                          >
                                            <i className="material-icons">
                                              visibility
                                            </i>
                                          </button>
                                        )}
                                      {sessionService.canViewSection(
                                        "Facturas.add"
                                      ) &&
                                        payment.cfdi == null && (
                                          <button
                                            onClick={() =>
                                              this.generateInvoice(payment.id)
                                            }
                                            style={{ margin: 5 }}
                                            type="button"
                                            className="btn btn-success"
                                          >
                                            <i className="material-icons">
                                              receipt
                                            </i>
                                          </button>
                                        )}
                                      {sessionService.canViewSection(
                                        "Facturas.delete"
                                      ) &&
                                        payment.cfdi != null && (
                                          <button
                                            onClick={() =>
                                              this.cancelInvoice(payment.id)
                                            }
                                            style={{ margin: 5 }}
                                            type="button"
                                            className="btn btn-danger"
                                          >
                                            <i className="material-icons">
                                              close
                                            </i>
                                          </button>
                                        )}
                                    </td>
                                  </tr>
                                </Fragment>
                              );
                            })}
                          {this.searching !== true &&
                            this.payments.map((payment: any, index: any) => {
                              const backgroundColor = () => {
                                if (
                                  (payment.type === "Deposito" ||
                                    payment.type === "Transferencia") &&
                                  payment.status === "Aprobado"
                                ) {
                                  return "approved";
                                }

                                if (
                                  (payment.type === "Deposito" ||
                                    payment.type === "Transferencia") &&
                                  payment.status === "Rechazado"
                                ) {
                                  return "rejected";
                                }

                                if (
                                  (payment.type === "Deposito" ||
                                    payment.type === "Transferencia") &&
                                  payment.status === "Pendiente"
                                ) {
                                  return "pending";
                                }

                                return "approved";
                              };

                              return (
                                <Fragment key={index}>
                                  <tr className={backgroundColor()}>
                                    <td>{payment.id}</td>
                                    <td
                                      onClick={() => {
                                        const baseUrl = new URL(
                                          apiUrl().url.API_URL
                                        ).hostname;
                                        const contractId =
                                          baseUrl ===
                                          "wirserv.serviciosinalambricos.com.mx"
                                            ? `W${payment.contract_id}`
                                            : payment.contract_id;
                                        if (contractId)
                                          history.push(
                                            `/contratos/ver/${contractId}`
                                          );
                                      }}
                                      style={{ cursor: "pointer" }}
                                    >
                                      {" "}
                                      {payment.contract_id}
                                    </td>
                                    <td
                                      onClick={() =>
                                        payment.invoice_id
                                          ? history.push(
                                              `/recibos/ver/${payment.invoice_id}`
                                            )
                                          : ""
                                      }
                                      style={{ cursor: "pointer" }}
                                    >
                                      {payment.invoice_id
                                        ? payment.invoice_id
                                        : "A favor"}
                                    </td>
                                    <td>{payment.client_name}</td>
                                    <td>{payment.cutoff_date}</td>
                                    <td>{payment.phone}</td>
                                    <td>
                                      {payment.type === "Deposito" ||
                                      payment.type === "Transferencia"
                                        ? payment.status
                                        : ""}
                                    </td>
                                    <td>{payment.date}</td>
                                    <td>{payment.type}</td>
                                    <td>{payment.address}</td>
                                    <td>{payment.amount}</td>
                                    <td>
                                      {formatRelative(
                                        new Date(payment.created_date),
                                        new Date(),
                                        { locale: es }
                                      )}
                                    </td>
                                    <td className="td-actions text-right">
                                      {sessionService.canViewSection(
                                        "Facturas.view"
                                      ) &&
                                        payment.cfdi != null && (
                                          <button
                                            onClick={() =>
                                              this.downLoadInvoice(payment.id, payment.cfdi)
                                            }
                                            style={{ margin: 5 }}
                                            type="button"
                                            className="btn btn-info"
                                          >
                                            <i className="material-icons">
                                              visibility
                                            </i>
                                          </button>
                                        )}
                                      {sessionService.canViewSection(
                                        "Facturas.add"
                                      ) &&
                                        payment.cfdi == null && (
                                          <button
                                            onClick={() =>
                                              this.generateInvoice(payment.id)
                                            }
                                            style={{ margin: 5 }}
                                            type="button"
                                            className="btn btn-success"
                                          >
                                            <i className="material-icons">
                                              receipt
                                            </i>
                                          </button>
                                        )}
                                      {sessionService.canViewSection(
                                        "Facturas.delete"
                                      ) &&
                                        payment.cfdi != null && (
                                          <button
                                            onClick={() =>
                                              this.cancelInvoice(payment.id)
                                            }
                                            style={{ margin: 5 }}
                                            type="button"
                                            className="btn btn-danger"
                                          >
                                            <i className="material-icons">
                                              close
                                            </i>
                                          </button>
                                        )}
                                    </td>
                                  </tr>
                                </Fragment>
                              );
                            })}
                        </tbody>
                      </table>
                    </div>
                    {this.total > 50 && (
                      <div className="row">
                        <Pagination
                          activePage={this.page}
                          itemsCountPerPage={50}
                          totalItemsCount={Number(this.total)}
                          pageRangeDisplayed={5}
                          onChange={this.changePage.bind(this)}
                          activeClass="btn-warning"
                          itemClass="btn btn-round btn-info"
                          innerClass="btn-group paginador"
                          disabledClass="deshabilitado"
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </Fragment>
        );
    }
}